import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e2222a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-section" }
const _hoisted_2 = { class: "mb-[92px]" }
const _hoisted_3 = { class: "mb-[92px]" }
const _hoisted_4 = { class: "mb-[104px]" }
const _hoisted_5 = { class: "mb-[92px]" }
const _hoisted_6 = { class: "mb-[92px]" }
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = { class: "relative mb-[92px]" }

import FirstSection from './Sections/FirstSection.vue';
import SecondSection from './Sections/SecondSection.vue';
import ThirdSection from './Sections/ThirdSection.vue';
import FourthSection from './Sections/FourthSection.vue';
import FifthSection from './Sections/FifthSection.vue';
import SixthSection from './Sections/SixthSection.vue';
import SeventhSection from './Sections/SeventhSection.vue';
import EighthSection from './Sections/EighthSection.vue';
import NinthSection from './Sections/NinthSection.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(FirstSection)
    ]),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(SecondSection)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(ThirdSection)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createVNode(FourthSection)
    ]),
    _createElementVNode("section", null, [
      _createVNode(FifthSection)
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createVNode(SixthSection)
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createVNode(SeventhSection)
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createVNode(EighthSection)
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createVNode(NinthSection)
    ])
  ], 64))
}
}

})